var _react_refresh_temp_1;
var _react_refresh_temp_2;
_react_refresh_temp_2 = $RefreshSig$();
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useGetUserSelectedOptionQuery } from '../../../store/services/pollsApi';
import { store } from '../../../store';
import VoteForm from '../voteForm';
const MyVoteStatus = ({ pollId }) => {
    var _a;
    _react_refresh_temp_2();
    const { t } = useTranslation();
    const { data, isLoading } = useGetUserSelectedOptionQuery({
        pollId,
        userId: ((_a = store.getState().session.currentUser) === null || _a === void 0 ? void 0 : _a.userId) || '',
    });
    const [hasVoted, setHasVoted] = useState(false);
    const [showVoteForm, setShowVoteForm] = useState(false);
    useEffect(() => {
        if (!isLoading && data) {
            if (data.status) {
                setHasVoted(!!(data.voted && data.voted > 0));
            }
        }
    }, [data, isLoading]);
    const vote = () => {
        setShowVoteForm(true);
    };
    const onCloseForm = () => {
        setShowVoteForm(false);
    };
    return (_jsxs(_Fragment, { children: [_jsx("div", { className: "has-voted", children: hasVoted ? (_jsx("p", { className: "absolute left-2 bottom-2 text-xs dark:text-white", children: t('polls.you-voted') })) : (_jsx("button", { className: "absolute left-0 bottom-0 transition ease-in bg-primaryColor hover:bg-secondaryColor text-[10px] text-white pt-1 pb-[2px] px-3 uppercase rounded-tr-lg", onClick: () => vote(), children: t('polls.vote') })) }), showVoteForm ? (_jsx(VoteForm, { onCloseForm: onCloseForm, pollId: pollId })) : null] }));
};
_react_refresh_temp_1 = MyVoteStatus;
$RefreshReg$(_react_refresh_temp_1, "MyVoteStatus");
_react_refresh_temp_2(MyVoteStatus, "7RIFRClxjGcusMkN3VZj0BBzDo8=", false, () => [useTranslation, useGetUserSelectedOptionQuery]);
export default MyVoteStatus;
